import React from "react";
import Navbar from "../Header/Navbar";
import { About_EatCoast, HowItWorks, Partners, WhyChoseUs, Slider_Component, OurTeam, OurLocation, FAQ } from "./Components/Compoents";
import Footer from "../Footer/Footer";
import { Box } from "@mui/material";


function About() {
  return (
    <>
      <Box sx={{
        width: '100%',
        overflowX: 'hidden'
      }}>
        <Navbar />
        <About_EatCoast />
        <HowItWorks />
        <Box sx={{ mt: { xl: '70px', lg: '0px' }, mb: { xl: '90px', lg: '0px' } }}><Partners /></Box>
        <WhyChoseUs />
        <Slider_Component />
        <OurTeam />
        <OurLocation />
        <FAQ />
        <Footer />
      </Box>
    </>
  );
}

export default About;
